import { useMemo } from 'react';
import { FeatureFlag } from 'types/features';
import { EFFORT_ACTIVITY_TYPE, LastEffortType, lastEffortTypeOf } from 'utils/lastEffortType';
import { useClassifiers } from 'utils/useClassifiers';
import { useIsFeatureEnabled } from 'utils/useFeatureFlags';

const CLASSIFIER_CODES = [EFFORT_ACTIVITY_TYPE];

/** {@link lastEffortTypeOf} of the loaded classifier list; null while the LAST_HCS_MEETING flag is off for the user. */
export const useLastEffortType = (): LastEffortType | null => {
    const isFlagOn = useIsFeatureEnabled(FeatureFlag.LAST_HCS_MEETING);
    const { classifiers } = useClassifiers({ codes: CLASSIFIER_CODES });
    const configured = useMemo(() => lastEffortTypeOf(classifiers[EFFORT_ACTIVITY_TYPE]), [classifiers]);
    return isFlagOn ? configured : null;
};
